module.exports = __webpack_public_path__ + "static/img01-b54dfaeb7c01d8a64e2941833464f014.png";